(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cw-better-offer"] && !Shopify.designMode) return;
  try {
    const openBetterOfferFeedback = () => {
    document.querySelectorAll('.cw-better-offer__modal').forEach((modal) => {
      if (!modal.querySelector('[data-better-offer-feedback]')) return;
      const opener = document.querySelector(`[data-modal="#${modal.id}"] button`);
      modal.show(opener);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openBetterOfferFeedback);
  } else {
    openBetterOfferFeedback();
  }
  } catch(e) { console.error(e); }
})();

})();
